export default {
  SET_OMNIBUS_WALLET_OWNER_DETAILS_GENERAL(state, generalInfo) {
    state.details.general = generalInfo;
  },
  CHANGE_DETAILS_EDITABLE_BLOCK(state, blockName) {
    state.details.editableBlock = blockName;
  },
};
